import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { FoodStock, FoodStockList } from '../../domain/models/FoodStock'
import { FoodStockFoodList } from '../../domain/models/FoodStockFood'
import {
  FoodStockFoodItem,
  FoodStockFoodItemList
} from '../../domain/models/FoodStockFoodItem'
import { PatientFoodStockList } from '../../domain/models/PatientFoodStockList'
import { FoodStockDatasource } from '../../infra/datasources/FoodStockDatasource'

export const foodStockDatasource: FoodStockDatasource = {
  async createFoodStock(data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/food-stocks`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    return FoodStock.parse(await response.json())
  },
  async updateFoodStockMinimumQuantity(stockFoodId, data) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/stocks-foods/${stockFoodId}`,
          httpTokenInterceptor({
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
  },
  async listAllPatientsFoodStock() {
    const response = await httpAuthenticationInterceptor(
      await HTTPExceptionInterceptor(
        await fetch(
          `${API_URL}/v2/food-stocks/patients`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )

    return PatientFoodStockList.parse(await response.json())
  },
  async listPatientFoodStock(patientId) {
    const response = await httpAuthenticationInterceptor(
      await HTTPExceptionInterceptor(
        await fetch(
          `${API_URL}/v2/patients/${patientId}/food-stocks`,
          httpTokenInterceptor({ method: 'GET' })
        )
      )
    )

    return FoodStockList.parse(await response.json())
  },
  async deleteFoodStock(foodStockId) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/food-stocks/${foodStockId}`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  },

  async createFoodStockFood(data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/food-stocks-items`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    return FoodStockFoodList.parse(await response.json())
  },

  async createFoodStockFoodItem(data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/food-stocks`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    return FoodStockFoodItemList.parse(await response.json())
  },
  async deleteFoodStockFoodItem(foodStockItemId) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/food-stocks-item/${foodStockItemId}`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  },
  async deleteFoodStockItem(foodStockId) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/stocks-food/${foodStockId}`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  },
  async createItemFoodStock(data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v2/food-items`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )
    return FoodStockFoodItem.array().parse(await response.json())
  }
}
